import {
  ContentPageSectionVisibility,
  PlannerConfigEntityPhraseStrings,
} from '@/services/configurator/PlannerConfigTypes';
import { Appointment } from '../common/appointment';
import { Banner } from '../common/banner';
import { Intro } from '../common/intro';
import { renderPhraseString } from '../../util';
import { ContentPageVariant } from '@pnpmworkspace/shared-types';

export const Banners = ({
  imageUrl,
  plannerUrl,
  phraseStrings,
  secondaryBannerImgUrl,
  contentPageVariant,
  dynamicView,
}: {
  plannerUrl?: string;
  imageUrl?: string;
  phraseStrings?: PlannerConfigEntityPhraseStrings;
  secondaryBannerImgUrl?: string;
  contentPageVariant?: ContentPageVariant;
  dynamicView?: ContentPageSectionVisibility;
}) => {
  return (
    <div className='flex flex-wrap gap-8'>
      <Intro
        title={renderPhraseString('page-intro-title', phraseStrings)}
        description={renderPhraseString(
          'page-intro-description',
          phraseStrings,
        )}
      />
      <Banner
        title={
          renderPhraseString('page-primary-banner-title', phraseStrings) ||
          renderPhraseString('planner.fallback-title', phraseStrings)
        }
        description={
          renderPhraseString(
            'page-primary-banner-description',
            phraseStrings,
          ) || renderPhraseString('large-description', phraseStrings)
        }
        cta={
          renderPhraseString('page-primary-banner-cta', phraseStrings) ||
          renderPhraseString('planner.fallback-cta', phraseStrings)
        }
        image={
          imageUrl ||
          renderPhraseString(
            'page-primary-banner-img-url-fallback',
            phraseStrings,
          )
        }
        alt={renderPhraseString('page-primary-banner-alt-text', phraseStrings)}
        linkTo={plannerUrl || ''}
        loading='eager'
        componentType='planner_banner'
        testId='plann-primary-banner'
        contentPageVariant={contentPageVariant}
      />
      {dynamicView && dynamicView['pageSecondaryBanner'] && (
        <Banner
          title={renderPhraseString(
            'page-secondary-banner-title',
            phraseStrings,
          )}
          description={renderPhraseString(
            'page-secondary-banner-description',
            phraseStrings,
          )}
          cta={renderPhraseString('page-secondary-banner-cta', phraseStrings)}
          image={secondaryBannerImgUrl}
          alt={renderPhraseString(
            'page-secondary-banner-img-alt-text',
            phraseStrings,
          )}
          // should come from marketData
          linkTo='testLink'
          componentType='services_banner'
          contentPageVariant={contentPageVariant}
        />
      )}
      <Appointment
        appointment1={{
          title: renderPhraseString('page-primary-card-title', phraseStrings),
          description: renderPhraseString(
            'page-primary-card-description',
            phraseStrings,
          ),
          bookButton: renderPhraseString(
            'page-primary-card-cta',
            phraseStrings,
          ),
          bookUrl: 'page-primary-card-cta-url',
        }}
        appointment2={{
          title: renderPhraseString('page-secondary-card-title', phraseStrings),
          description: renderPhraseString(
            'page-secondary-card-description',
            phraseStrings,
          ),
          bookButton: renderPhraseString(
            'page-secondary-card-cta',
            phraseStrings,
          ),
          bookUrl: 'page-secondary-card-cta-url',
        }}
        contentPageVariant={contentPageVariant}
        dynamicView={dynamicView}
      />
    </div>
  );
};
